module.exports = __webpack_public_path__ + "static/media/Profile_Photo_3@3x.95e640f2.png";